import { CarbonInjection } from "@/pages/eaf/data-entry/models/eaf.models";
import { getMomentTz } from "@dexteel/mesf-core";
import { ColGroupDef, ValueGetterParams } from "ag-grid-enterprise";
const moment = getMomentTz();

export const useTableData = () => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Injections",
      children: [
        {
          field: "Type",
          headerName: "",
          flex: 1,
        },
        {
          field: "Injector1",
          headerName: "Inj 1",
          valueGetter: (params: ValueGetterParams<CarbonInjection>) => {
            return params?.data?.Injector1
              ? params.data.Injector1.toFixed(1)
              : "0";
          },
          flex: 1,
        },
        {
          field: "Injector2",
          headerName: "Inj 2",
          valueGetter: (params: ValueGetterParams<CarbonInjection>) => {
            return params?.data?.Injector2
              ? params.data.Injector2.toFixed(1)
              : "0";
          },
          flex: 1,
        },
        {
          field: "Injector3",
          headerName: "Inj 3",
          valueGetter: (params: ValueGetterParams<CarbonInjection>) => {
            return params?.data?.Injector3
              ? params.data.Injector3.toFixed(1)
              : "0";
          },
          flex: 1,
        },
        {
          field: "InjectorDoor",
          headerName: "Door",
          valueGetter: (params: ValueGetterParams<CarbonInjection>) => {
            return params?.data?.InjectorDoor
              ? params.data.InjectorDoor.toFixed(1)
              : "0";
          },
          flex: 1,
        },
      ],
    },
  ];

  return { columns };
};
